// One invoice as a row in a drawer's list (finance-real, the user 2026-10-23: "same entities should use same
// components"): the client drawer's invoices and the person drawer's team invoices. Its name (invoiceName), its
// status-date line and what it counts ("2 jobs", "3 claims") under it, its status as the shared read-only pill (it changes
// in the invoice's drawer, DD-062) and its amount. A saved row carries no button of its own (DD-045): the whole row opens
// the invoice's drawer, and its one accessible name says the row in that order. On a phone the pill sits over the
// amount, so neither leaves the row (DD-055). A child that only displays its props: no hook (TD-107).
import { MoneyText } from "@/components/ui/MoneyText";
import { formatMoney } from "@/utils/currency";
import type { StatusLook } from "../clientPage/lineJobText";
import { StatusPill } from "../clientPage/StatusBadge";

interface Props {
  name: string;
  /** invoiceDateLine's: "Sent 18 Sep 2026", "Draft · started 3 Oct 2026". */
  dateLine: string;
  /** "2 jobs" on a client invoice, "3 claims" on a team invoice. */
  count: string;
  look: StatusLook;
  amountMinor: number;
  onOpen: () => void;
}

export function InvoiceListRow({ name, dateLine, count, look, amountMinor, onOpen }: Props) {
  return (
    <button
      type="button"
      aria-label={`${name}, ${dateLine}, ${count}, ${look.label}, ${formatMoney(amountMinor, "EUR")}`}
      onClick={onOpen}
      className="w-full flex items-center gap-3 py-2 text-left text-sm hover:bg-gray-50"
    >
      <span className="min-w-0 flex-1">
        <span className="block text-gray-900 [overflow-wrap:anywhere]">{name}</span>
        <span className="block text-xs text-gray-500 [overflow-wrap:anywhere]">{`${dateLine} · ${count}`}</span>
      </span>
      <span className="flex shrink-0 flex-col items-end gap-1 sm:flex-row sm:items-center sm:gap-3">
        <StatusPill look={look} />
        <MoneyText amountMinor={amountMinor} className="sm:w-24 text-right" />
      </span>
    </button>
  );
}
